import {
  Button,
  Modal,
  Radio,
  Row,
  Space,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useEffect, useState } from "react";
import "./GrossFee.css";
import FloatingInput from "../../common/float-input/FloatInput";
import { useDispatch, useSelector } from "react-redux";
import { grossFeeRequest } from "../../../store/thunks/buyer-thunks/BuyerThunks";
const GrossFee = ({
  grossFeeModal,
  setGrossFeeModal,
  campaignId,
  grossFeeVal,
}) => {
  const { Text } = Typography;
  const [grossFee, setGrossFee] = useState(1);
  const [grossPrecentage, setGrossPercentage] = useState("");
  const dispatch = useDispatch();
  const options = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];
  const { isLoading } = useSelector((state) => state?.grossfee);
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  useEffect(() => {
    if (grossFeeModal) {
      // Set radio based on parent value
      // If parent sends % then radio should be YES
      if (
        grossFeeVal !== null &&
        grossFeeVal !== undefined &&
        grossFeeVal !== ""
      ) {
        setGrossFee(1); // Yes selected
        setGrossPercentage(grossFeeVal); // Set input
      } else {
        setGrossFee(0); // No selected
        setGrossPercentage(""); // Empty input
      }
    }
  }, [grossFeeModal, grossFeeVal]);
  const onChange = ({ target: { value } }) => {
    setGrossFee(value);
  };

  const handleCancel = () => {
    setGrossFeeModal(false);
    setGrossFee(0); // reset radio
    setGrossPercentage(""); // clear input
  };
  const handleGrossPercentage = () => {
    const payload = {
      id: campaignId,
      gross_fee_percentage: grossPrecentage,
      gross_fee_percentage_status: grossFee,
    };
    setGrossFeeModal(false);
    dispatch(grossFeeRequest(payload));
  };
  const isGrossPercentageInvalid =
    grossFee === 1 && (!grossPrecentage || /^0/.test(String(grossPrecentage)));
  return (
    <>
      <Modal
        open={grossFeeModal}
        onCancel={handleCancel}
        closable={true}
        className="gross-fee-modal"
        footer={false}
        centered
      >
        <Row>
          <Text className="gross-fee-text">Gross Fee Percentage %</Text>
        </Row>
        <Space direction="vertical" size={15} style={{ width: "100%" }}>
          <Row>
            <Text className="gross-fee">Gross Status</Text>
          </Row>
          <Row>
            <Radio.Group
              options={options}
              onChange={onChange}
              value={grossFee}
            />
          </Row>
          {grossFee === 1 ? (
            <>
              <Row>
                <FloatingInput
                  className="billboard-input-feild"
                  label={<>{`Gross Percentage %`}</>}
                  customStyles={floatingInputStyles}
                  value={grossPrecentage}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) {
                      setGrossPercentage(e.target.value);
                    }
                  }}
                />
              </Row>
            </>
          ) : (
            <></>
          )}
          <Row justify="end">
            <Space size={10}>
              <Button className="gross-fee-cnl-btn">
                <Text className="gross-fee-cnl-btn-txt" onClick={handleCancel}>
                  Cancel
                </Text>
              </Button>
              <Button
                className={`gross-fee-sve-btn ${
                  isGrossPercentageInvalid ? "disabled-opacity" : ""
                }`}
                disabled={isGrossPercentageInvalid}
                type="primary"
              >
                <Text
                  className="gross-fee-sve-btn-txt"
                  onClick={handleGrossPercentage}
                >
                  Save
                </Text>
              </Button>
            </Space>
          </Row>
        </Space>
      </Modal>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};
export default GrossFee;
